export default __webpack_public_path__ + "static/media/Icon=planner.482e4048.svg";